<template>
  <main class="terminal-stamp-main">
    <section class="terminal-stamp-options" aria-label="Terminal stamp type">
      <button
        v-for="option in stampOptions"
        :key="option.type"
        type="button"
        class="terminal-stamp-option"
        @click="openTerminalStamp(option.routeName)"
      >
        <img
          :src="option.image"
          :alt="option.alt"
          decoding="async"
          class="terminal-stamp-option__image"
        />
        <span class="terminal-stamp-option__overlay" aria-hidden="true"></span>
        <span class="terminal-stamp-option__title">{{ option.title }}</span>
      </button>
    </section>
  </main>
</template>

<script>
export default {
  name: "TerminalStampMain",
  data() {
    return {
      stampOptions: [
        {
          type: "rabbit",
          routeName: "TerminalStampRabbit",
          title: "Rabbit Card Stamp",
          alt: "Rabbit card",
          image: require("@/assets/rabbit_logo.webp"),
        },
        {
          type: "ticket",
          routeName: "TerminalStamp",
          title: "Scan QR-Code",
          alt: "Parking ticket with QR code",
          image: require("@/assets/ticket_logo.webp"),
        },
      ],
    };
  },
  methods: {
    openTerminalStamp(routeName) {
      this.$router.push({ name: routeName });
    },
  },
};
</script>

<style scoped>
@font-face {
  font-family: "Mrs Eaves Lining OT";
  src: url("~@/assets/Font/Lining.otf") format("opentype");
  font-display: swap;
}

.terminal-stamp-main {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: calc(100vh - 158px);
  padding: 64px 32px;
  background: #ffffff;
}

.terminal-stamp-options {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 58px;
  width: 100%;
}

.terminal-stamp-option {
  position: relative;
  width: min(420px, 40vw);
  height: 500px;
  padding: 0;
  overflow: hidden;
  color: #ffffff;
  background: #f4f3f2;
  border: 1px solid #231f20;
  border-radius: 14px;
  box-shadow: 0 7px 10px rgba(35, 31, 32, 0.24);
  cursor: pointer;
  transition: transform 180ms cubic-bezier(0.22, 1, 0.36, 1),
    box-shadow 180ms cubic-bezier(0.22, 1, 0.36, 1);
}

.terminal-stamp-option:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 12px rgba(35, 31, 32, 0.28);
}

.terminal-stamp-option:focus-visible {
  outline: 3px solid #126496;
  outline-offset: 4px;
}

.terminal-stamp-option:active {
  transform: translateY(-1px);
}

.terminal-stamp-option__image {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.terminal-stamp-option__overlay {
  position: absolute;
  inset: 0;
  background: linear-gradient(
    to bottom,
    rgba(35, 31, 32, 0) 54%,
    rgba(35, 31, 32, 0.22) 72%,
    rgba(35, 31, 32, 0.82) 100%
  );
  pointer-events: none;
}

.terminal-stamp-option__title {
  position: absolute;
  right: 24px;
  bottom: 52px;
  left: 24px;
  z-index: 1;
  font-family: "Mrs Eaves Lining OT", "Times New Roman", serif;
  font-size: 32px;
  line-height: 1.15;
  letter-spacing: 0.02em;
  text-align: center;
  text-shadow: 0 1px 3px rgba(35, 31, 32, 0.35);
}

@media (max-width: 959px) {
  .terminal-stamp-main {
    align-items: flex-start;
    min-height: calc(100vh - 144px);
    padding: 48px 24px;
  }

  .terminal-stamp-options {
    gap: 28px;
  }

  .terminal-stamp-option {
    width: min(390px, 44vw);
    height: 460px;
  }

  .terminal-stamp-option__title {
    bottom: 40px;
    font-size: 28px;
  }
}

@media (max-width: 600px) {
  .terminal-stamp-main {
    padding: 32px 18px 44px;
  }

  .terminal-stamp-options {
    flex-direction: column;
    gap: 24px;
  }

  .terminal-stamp-option {
    width: min(100%, 420px);
    height: 420px;
  }

  .terminal-stamp-option__title {
    bottom: 34px;
    font-size: 26px;
  }
}

@media (prefers-reduced-motion: reduce) {
  .terminal-stamp-option {
    transition: none;
  }
}
</style>
